// extracted by mini-css-extract-plugin
module.exports = {"separator":"separator_style_separator__Obsy3"};